export default __webpack_public_path__ + "static/media/logo.15dff215.svg";